import { Star, Quote } from "lucide-react";
import { TESTIMONIALS, RATING_STATS } from "@/data/testimonials";
import useSEO from "@/hooks/useSEO";

// Reviews section with AggregateRating + Review JSON-LD → gets stars in Google.
export default function TestimonialsSection() {
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "HealthAndBeautyBusiness",
        "@id": "https://massoclic.ca/#business",
        name: "Jérémy Tessier — Massothérapie",
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: RATING_STATS.average,
            reviewCount: RATING_STATS.count,
            bestRating: 5,
            worstRating: 1,
        },
        review: TESTIMONIALS.map((t) => ({
            "@type": "Review",
            author: { "@type": "Person", name: t.name },
            reviewRating: { "@type": "Rating", ratingValue: t.rating, bestRating: 5 },
            reviewBody: t.text,
            datePublished: t.date,
        })),
    };
    useSEO({ jsonLd });

    return (
        <section
            id="avis"
            data-testid="testimonials-section"
            className="py-20 md:py-28 bg-[#FAF7F2] scroll-mt-24"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-8 items-end mb-12">
                    <div className="lg:col-span-7">
                        <div className="text-xs tracking-[0.3em] uppercase text-[#E07A5F] mb-4">
                            Ils en parlent
                        </div>
                        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light text-[#2C2A29] tracking-tight leading-tight">
                            La confiance de{" "}
                            <span className="italic text-[#E07A5F]">{RATING_STATS.count}+ clients</span> sur la Rive-Nord.
                        </h2>
                    </div>
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-3">
                            <div className="flex items-center gap-1">
                                {[1, 2, 3, 4, 5].map((n) => (
                                    <Star key={n} size={22} className="fill-[#E07A5F] text-[#E07A5F]" />
                                ))}
                            </div>
                            <div>
                                <div className="font-display text-3xl text-[#2C2A29]">{RATING_STATS.average} / 5</div>
                                <div className="text-xs text-[#6E6862]">
                                    Basé sur {RATING_STATS.count} avis clients
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {TESTIMONIALS.map((t) => (
                        <div
                            key={t.id}
                            data-testid={`testimonial-${t.id}`}
                            className="relative rounded-3xl bg-white border border-[#E8E2D9] p-6 md:p-7 shadow-[0_8px_30px_rgba(44,42,41,0.04)] hover:shadow-[0_20px_60px_rgba(44,42,41,0.08)] transition-all duration-500 hover:-translate-y-1"
                        >
                            <Quote size={26} className="text-[#3D8C95]/30 mb-3" />
                            <p className="text-sm text-[#2C2A29] leading-relaxed italic">
                                « {t.text} »
                            </p>
                            <div className="mt-5 pt-5 border-t border-[#E8E2D9]">
                                <div className="flex items-center gap-1 mb-1">
                                    {Array.from({ length: t.rating }).map((_, i) => (
                                        <Star key={i} size={13} className="fill-[#E07A5F] text-[#E07A5F]" />
                                    ))}
                                </div>
                                <div className="font-display text-lg text-[#2C2A29]">{t.name}</div>
                                <div className="text-xs text-[#6E6862]">
                                    {t.city} · {t.service}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
